export default Backbone.Model.extend({
    idAttribute: 'share_code'
}, {
    type: 'sharedContent'
});
